<template>
  <div>
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>

    <div class="note-container" style="font-family: 'Poppins', sans-serif; overflow-y: auto;">
      <div class="create-order" style="min-width: 1200px;">
        <div class="left">
          <h3 class="order-type">Orden de Taller: {{ localOrderDetails.order_number }}</h3>
        </div>
        <div class="right">
          <button @click="showForm('initialData')" :class="{ active: currentForm === 'initialData' }">Información General</button>
          <button @click="showForm('billing')" :class="{ active: currentForm === 'billing' }">Facturas</button>
        </div>
      </div>

      <div v-if="currentForm === 'initialData'" style="min-width: 1200px;">
        <div class="main-data-container">
          <div class="container-card maintenance-general">
            <div class="title maintenance-title-row">
              <h4>Información General</h4>
              <span class="folio-badge">Folio: {{ localOrderDetails.order_number }}</span>
            </div>
            <div class="container-card-body">
              <div class="maintenance-general-grid">
                <div class="maintenance-column">
                  <div class="form-input-group">
                    <label>Unidad:</label>
                    <select v-model="localOrderDetails.unit">
                      <option value="">Seleccione</option>
                      <option v-for="u in units" :key="u.unit_id" :value="u.id">
                        {{ u.unit_short_id }} - {{ u.unit_plates }}
                      </option>
                    </select>
                  </div>

                  <div class="form-input-group">
                    <label>Sucursal:</label>
                    <select v-model="localOrderDetails.sucursal">
                      <option value="">Seleccione</option>
                      <option v-for="branch in sucursales" :key="branch" :value="branch">
                        {{ branch }}
                      </option>
                    </select>
                  </div>

                  <div class="form-input-group">
                    <label>KM Recorridos:</label>
                    <input type="number" min="0" v-model.number="localOrderDetails.odometer_reading" />
                  </div>

                  <div class="form-input-group">
                    <label>Vo. Bueno:</label>
                    <select v-model="localOrderDetails.signed_off_by">
                      <option value="">Seleccione</option>
                      <option v-for="emp in employees" :key="emp.id" :value="emp.id">
                        {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                      </option>
                    </select>
                  </div>

                  <div class="form-input-group">
                    <label>Operador:</label>
                    <select v-model="localOrderDetails.operator">
                      <option value="">Seleccione</option>
                    <option v-for="emp in operatorEmployees" :key="emp.id" :value="emp.id">
                        {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="maintenance-column">
                  <div class="form-input-group">
                    <label>Motivo:</label>
                    <select v-model="localOrderDetails.motive_of_service">
                      <option value="">Seleccione</option>
                      <option v-for="cause in motives" :key="cause" :value="cause">{{ cause }}</option>
                    </select>
                  </div>

                  <div class="form-input-group">
                    <label>Causa:</label>
                    <select v-model="localOrderDetails.cause">
                      <option value="">Seleccione</option>
                      <option v-for="item in causes" :key="item" :value="item">{{ item }}</option>
                    </select>
                  </div>

                  <div class="form-input-group">
                    <label>Hrs. Trabajadas:</label>
                    <input type="text" :value="worked_hours_display" disabled />
                  </div>

                  <div class="form-input-group">
                    <label>Severidad:</label>
                    <div class="radio-group">
                      <label><input type="radio" value="Mayor" v-model="localOrderDetails.repair_severity" /> Mayor</label>
                      <label><input type="radio" value="Menor" v-model="localOrderDetails.repair_severity" /> Menor</label>
                    </div>
                  </div>

                  <div class="form-input-group">
                    <label>Incidencia:</label>
                    <input type="text" v-model="incidence" disabled />
                  </div>
                </div>
              </div>

              <div class="form-input-group full-width">
                <label>Falla:</label>
                <textarea v-model="localOrderDetails.service_description"></textarea>
              </div>
            </div>
          </div>

          <div class="maintenance-side">
            <div class="container-card">
              <div class="title">
                <h4>Tiempos</h4>
              </div>
              <div class="container-card-body">
              <div v-if="showMechanicStartDisclaimer" class="time-disclaimer">
                Mecánicos reportan inicio pero orden de mantenimiento no
              </div>
                <div class="form-input-group">
                  <label>Solicitud:</label>
                  <input type="datetime-local" :value="formatDatetime(localOrderDetails.request_time)" disabled />
                </div>
                <div class="form-input-group">
                  <label>Programada para:</label>
                  <input type="datetime-local" v-model="localOrderDetails.scheduled_for" />
                </div>
                <div class="form-input-group">
                  <label>Recepción:</label>
                  <input type="datetime-local" v-model="localOrderDetails.reception_time" />
                </div>
                <div class="form-input-group">
                  <label>Inicio:</label>
                  <input type="datetime-local" v-model="localOrderDetails.start_time" />
                </div>
                <div class="form-input-group">
                  <label>Salida Aprox.:</label>
                  <input type="datetime-local" v-model="localOrderDetails.estimated_end_time" />
                </div>
                <div class="form-input-group">
                  <label>Término:</label>
                  <input type="datetime-local" v-model="localOrderDetails.end_time" />
                </div>
              </div>
            </div>

            <div class="container-card">
              <div class="title">
                <h4>Costos</h4>
              </div>
              <div class="container-card-body">
                <div class="form-input-group">
                  <label>Refacciones:</label>
                  <input
                    type="number"
                    :value="localOrderDetails.parts_cost"
                    disabled
                    title="Se calcula automáticamente desde los vales de salida vinculados"
                  />
                </div>
                <div class="form-input-group">
                  <label>Mano de Obra:</label>
                  <input type="number" min="0" v-model.number="localOrderDetails.labor_cost" />
                </div>
                <div class="form-input-group">
                  <label>Total:</label>
                  <input type="number" :value="total_cost" disabled />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-card tallers-card" style="min-width: 1200px;">
          <div class="title">
            <h4>Mecánicos</h4>
            <button v-if="canUpdate" class="btn-submit-save" @click.prevent="addAssignation">Agregar</button>
          </div>
          <div class="container-card-body">
            <div class="assignations-actions">
            </div>

            <div class="assignations-extra-fields">
              <div v-for="(assignation, index) in localAssignations" :key="assignation.localKey" class="grupo-block">
                <div class="assignation-row">
                  <label>Taller:</label>
                  <select v-model="assignation.workshop">
                    <option value="">Seleccione</option>
                    <option v-for="workshop in workshops" :key="workshop" :value="workshop">{{ workshop }}</option>
                  </select>
                </div>
                <div class="assignation-row">
                  <label>Mecánico:</label>
                  <select
                    :value="assignation.mechanic || ''"
                    @change="assignation.mechanic = $event.target.value ? Number($event.target.value) : null"
                  >
                    <option value="">Seleccione</option>
                    <option v-for="emp in mechanicEmployees" :key="emp.id" :value="emp.id">
                      {{ emp.employee_ident }} - {{ emp.employee_first_name }} {{ emp.employee_last_name }}
                    </option>
                  </select>
                </div>
                <div class="assignation-row">
                  <label>Tiempo de Entrada:</label>
                  <input type="datetime-local" v-model="assignation.start_time" />
                </div>
                <div class="assignation-row">
                  <label>Tipo de Servicio:</label>
                  <input type="text" v-model="assignation.type_of_maintenance" />
                </div>
                <div class="assignation-row">
                  <label>Tiempo de Salida:</label>
                  <input type="datetime-local" v-model="assignation.end_time" />
                </div>
                <div class="assignation-row assignation-row--comments">
                  <label>Comentarios:</label>
                  <textarea
                    class="assignation-comments"
                    v-model="assignation.comments"
                    rows="3"
                  ></textarea>
                </div>
                <div class="assignation-row">
                  <label>Estatus:</label>
                  <span class="status-pill" :class="statusClass(assignation.status)">
                    {{ statusLabel(assignation.status) }}
                  </span>
                </div>
                <div class="assignation-buttons">
                  <button
                    v-if="canUpdate"
                    class="btn-delete-icon"
                    @click.prevent="removeAssignation(assignation, index)"
                  >✕</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-card" style="min-width: 1200px;">
          <div class="title piezas-title">
            <h4>Requisiciones</h4>
            <button v-if="canCreateRequisition" class="btn-submit-save" @click.prevent="toggleRequisitionForm">
              {{ showRequisitionForm ? 'Cerrar' : 'Nueva requisición' }}
            </button>
          </div>
          <div class="container-card-body">
            <div v-if="showRequisitionForm" class="requisition-form">
              <div class="form-input-group">
                <label>Comentarios:</label>
                <textarea v-model="requisitionComments" rows="2"></textarea>
              </div>
              <div class="requisition-add-row">
                <button class="btn-submit-save" @click.prevent="addRequisitionItem">Agregar pieza</button>
              </div>
              <div v-for="(item, index) in requisitionItems" :key="index" class="requisition-item-row">
                <div class="part-suggest">
                  <input
                    type="text"
                    v-model="item.query"
                    placeholder="Nombre o código de la pieza"
                    autocomplete="off"
                    @input="onPartQuery(item)"
                    @focus="onPartFocus(item)"
                    @keydown.down.prevent="movePartSuggestion(item, 1)"
                    @keydown.up.prevent="movePartSuggestion(item, -1)"
                    @keydown.enter.prevent="confirmPartSuggestion(item)"
                    @blur="hidePartSuggestions(item)"
                  />
                  <ul v-if="item.showSuggestions && item.suggestions.length" class="part-suggestions">
                    <li
                      v-for="(part, suggestionIndex) in item.suggestions"
                      :key="part.id"
                      :class="{ hovered: suggestionIndex === item.highlight }"
                      @mousedown.prevent="selectPart(item, part)"
                    >
                      <strong>{{ part.barcode }}</strong> — {{ part.name }}
                      <span class="part-suggest-stock">stock {{ formatMoney(part.current_stock) }}</span>
                    </li>
                  </ul>
                </div>
                <input class="requisition-qty" type="number" min="0.01" step="0.01" v-model.number="item.quantity" placeholder="Cantidad" />
                <button class="btn-delete-icon" @click.prevent="requisitionItems.splice(index, 1)">✕</button>
              </div>
              <button class="btn-submit-save requisition-save" @click.prevent="saveRequisition" :disabled="savingRequisition">
                {{ savingRequisition ? 'Guardando...' : 'Guardar requisición' }}
              </button>
            </div>
            <div v-if="orderRequisitions.length === 0 && !showRequisitionForm" class="placeholder-text">
              Esta orden no tiene requisiciones. El taller las genera para pedir piezas al almacén.
            </div>
            <div v-for="requisition in orderRequisitions" :key="requisition.id" class="voucher-block">
              <div class="voucher-header">
                <span class="voucher-folio">{{ requisition.requisition_number }}</span>
                <span class="status-pill" :class="requisitionStatusClass(requisition.status)">{{ requisition.status_label }}</span>
                <span>{{ formatVoucherDate(requisition.created_at) }}</span>
                <span>{{ requisition.created_by_name || 'N/A' }}</span>
                <button class="btn-submit-save" @click.prevent="printOrderRequisition(requisition)">Imprimir</button>
                <button class="btn-submit-save" @click.prevent="printOrderRequisitionTicket(requisition)">Imprimir ticket</button>
              </div>
              <table class="piezas-table">
                <thead>
                  <tr>
                    <th>Surtida</th>
                    <th>Código</th>
                    <th>Pieza</th>
                    <th>Pedida</th>
                    <th>Entregada</th>
                    <th>Pendiente</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in requisition.items" :key="item.id">
                    <td><span class="req-check" :class="supplyClass(item)" :title="supplyLabel(item)"></span></td>
                    <td>{{ item.part_barcode }}</td>
                    <td>{{ item.part_name }}</td>
                    <td>{{ formatMoney(item.quantity) }} {{ item.part_unit_of_measure || '' }}</td>
                    <td>{{ formatMoney(item.delivered_quantity) }}</td>
                    <td>{{ formatMoney(item.remaining_quantity) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="container-card" style="min-width: 1200px;">
          <div class="title piezas-title">
            <h4>Piezas</h4>
          </div>
          <div class="container-card-body">
            <div v-if="linkedVouchers.length === 0" class="placeholder-text">
              No hay vales de salida en esta orden. Las piezas llegan cuando almacén surte una requisición.
            </div>
            <div v-for="voucher in linkedVouchers" :key="voucher.id" class="voucher-block">
              <div class="voucher-header">
                <span class="voucher-folio">{{ voucher.voucher_number }}</span>
                <span v-if="voucher.requisition_number">Requisición: {{ voucher.requisition_number }}</span>
                <span>Autorizó: {{ voucher.authorized_by_name || 'N/A' }}</span>
                <span>Recibió: {{ voucher.received_by_name || 'N/A' }}</span>
                <span>Fecha: {{ formatVoucherDate(voucher.created_at) }}</span>
              </div>
              <table class="piezas-table">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Pieza</th>
                    <th>Cantidad</th>
                    <th>Costo unitario</th>
                    <th>Subtotal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in voucher.items" :key="item.id">
                    <td>{{ item.part_barcode }}</td>
                    <td>{{ item.part_name }}</td>
                    <td>{{ formatMoney(item.quantity) }} {{ item.part_unit_of_measure || '' }}</td>
                    <td>${{ formatMoney(item.unit_cost_snapshot) }}</td>
                    <td>${{ formatMoney(item.subtotal) }}</td>
                  </tr>
                </tbody>
              </table>
              <div class="voucher-subtotal">Subtotal: ${{ formatMoney(voucher.total) }}</div>
            </div>
            <div v-if="linkedVouchers.length" class="piezas-total">
              Total refacciones: ${{ formatMoney(vouchersTotal) }}
            </div>
          </div>
        </div>

        <div class="form-actions" style="min-width: 1200px;">
        <button
          v-if="canUpdate"
          type="button"
          class="btn-submit-save"
          @click="saveAll"
          :disabled="savingOrder"
        >
            {{ savingOrder ? 'Guardando...' : 'Guardar' }}
          </button>
        <button
          v-if="canUpdate"
          type="button"
          class="btn-submit-complete"
          @click="completeOrder"
          :disabled="savingOrder || !canSave"
        >
          Completar
        </button>
          <button type="button" class="btn-submit-cancel" @click="backMaintenance">Cancelar</button>
        </div>
      <div v-if="missingSaveReasons.length" class="save-disclaimer" style="min-width: 1200px;">
        Faltan: {{ missingSaveReasons.join(', ') }}
      </div>
      </div>

      <div v-if="currentForm === 'billing'" style="min-width: 1200px;">
        <div class="container-card">
          <div class="title">
            <h4>Facturas</h4>
          </div>
          <div class="container-card-body">
            <div class="placeholder-text">Sección en construcción.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import { printRequisition } from '@/utils/printRequisition'
import { printRequisitionTicket } from '@/utils/printTicket'
import { normalizeScannedCode } from '@/utils/scannedCode'

export default {
  name: 'EditMaintenanceOrderForm',
  props: {
    orderDetails: { type: Object, default: () => ({}) },
    orderId: { type: [String, Number], default: null },
    assignations: { type: Array, default: () => [] },
    statusOptions: { type: Array, default: () => [] },
    username: { type: String, default: '' },
    user_id: { type: [String, Number], default: null },
    user_groups: { type: Array, default: () => [] },
  },
  data() {
    return {
      currentForm: 'initialData',
      localOrderDetails: {},
      localAssignations: [],
      incidence: '',
      motives: ['Correctivo', 'Preventivo'],
      causes: ['Negligencia', 'Desgaste', 'Colisión o Accidente', 'Mantenimiento', 'Otro (Especificar)'],
      workshops: ['Llantero', 'Mecanico', 'Electrico', 'Hidraulico', 'Soldadura', 'Hojalatería y Pintura'],
      sucursales: ['LINCOLN'],
      employees: [],
      operatorEmployees: [],
      mechanicEmployees: [],
      units: [],
      savingOrder: false,
      permissions: [],
      linkedVouchers: [],
      orderRequisitions: [],
      showRequisitionForm: false,
      requisitionComments: '',
      requisitionItems: [{
        part: '',
        query: '',
        quantity: null,
        suggestions: [],
        showSuggestions: false,
        highlight: 0,
      }],
      savingRequisition: false,
    }
  },
  computed: {
    total_cost() {
      const parts = Number(this.localOrderDetails.parts_cost) || 0
      const labor = Number(this.localOrderDetails.labor_cost) || 0
      return (parts + labor).toFixed(2)
    },
    worked_hours_display() {
      const start = this.localOrderDetails.start_time
      const end = this.localOrderDetails.end_time
      if (!start || !end) return 'FALTA INFORMACION'
      const startDate = new Date(start)
      const endDate = new Date(end)
      if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return 'FALTA INFORMACION'
      const diffMs = endDate.getTime() - startDate.getTime()
      if (diffMs < 0) return 'FALTA INFORMACION'
      const totalMinutes = Math.floor(diffMs / 60000)
      const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0')
      const minutes = String(totalMinutes % 60).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    showMechanicStartDisclaimer() {
      const orderStartMissing = !this.localOrderDetails.start_time
      const anyAssignationStarted = this.localAssignations.some((assignation) => Boolean(assignation.start_time))
      return orderStartMissing && anyAssignationStarted
    },
    canUpdate() {
      return this.permissions.includes('maintenance.update_order') ||
        this.permissions.includes('access_control.maintenance.update_order')
    },
    canCreateRequisition() {
      return this.canUpdate ||
        this.permissions.includes('maintenance.create_requisition') ||
        this.permissions.includes('access_control.maintenance.create_requisition')
    },
    vouchersTotal() {
      return this.linkedVouchers.reduce((sum, voucher) => sum + (Number(voucher.total) || 0), 0)
    },
    saveConditions() {
      return [
        {
          key: 'signedOff',
          ok: Boolean(this.localOrderDetails.signed_off_by),
          label: 'Vo. Bueno',
        },
        {
          key: 'hasAssignations',
          ok: this.localAssignations.length > 0,
          label: 'al menos una asignación',
        },
        {
          key: 'assignationsDone',
          ok: this.localAssignations.length > 0 && this.localAssignations.every((assignation) => assignation.status === 3),
          label: 'asignaciones terminadas',
        },
        {
          key: 'timesComplete',
          ok: Boolean(
            this.localOrderDetails.reception_time &&
            this.localOrderDetails.start_time &&
            this.localOrderDetails.estimated_end_time &&
            this.localOrderDetails.end_time
          ),
          label: 'tiempos completos',
        },
        {
          key: 'costsComplete',
          ok: this.isCostProvided(this.localOrderDetails.parts_cost) &&
            this.isCostProvided(this.localOrderDetails.labor_cost),
          label: 'costos completos',
        },
      ]
    },
    canSave() {
      return this.saveConditions.every((condition) => condition.ok)
    },
    missingSaveReasons() {
      return this.saveConditions.filter((condition) => !condition.ok).map((condition) => condition.label)
    },
  },
  mounted() {
    this.localOrderDetails = this.normalizeOrderDetails(this.orderDetails)
    if (!this.localOrderDetails.id && this.orderId) {
      this.localOrderDetails.id = Number(this.orderId)
    }
      this.localAssignations = this.assignations.map((item, index) => ({
      id: item.id,
      maintenance_order: item.maintenance_order || this.orderDetails.id,
      workshop: item.workshop || '',
        mechanic: item.mechanic?.id || item.mechanic || null,
      start_time: item.start_time ? item.start_time.slice(0, 16) : '',
      type_of_maintenance: item.type_of_maintenance || '',
      comments: item.comments || '',
      end_time: item.end_time ? item.end_time.slice(0, 16) : '',
      status: item.status?.id || item.status || '',
      localKey: item.id || `local-${index}`,
    }))
    this.fetchEmployees()
    this.fetchOperatorEmployees()
    this.fetchMechanicEmployees()
    this.fetchUnits()
    this.fetchLinkedVouchers()
    this.fetchOrderRequisitions()
  },
  watch: {
    orderDetails: {
      deep: true,
      handler(newVal) {
        this.localOrderDetails = this.normalizeOrderDetails(newVal)
        if (!this.localOrderDetails.id && this.orderId) {
          this.localOrderDetails.id = Number(this.orderId)
        }
      },
    },
    assignations: {
      deep: true,
      handler(newVal) {
        this.localAssignations = newVal.map((item, index) => ({
          id: item.id,
          maintenance_order: item.maintenance_order || this.orderDetails.id,
          workshop: item.workshop || '',
          mechanic: item.mechanic?.id || item.mechanic || null,
          start_time: item.start_time ? item.start_time.slice(0, 16) : '',
          type_of_maintenance: item.type_of_maintenance || '',
          comments: item.comments || '',
          end_time: item.end_time ? item.end_time.slice(0, 16) : '',
          status: item.status?.id || item.status || '',
          localKey: item.id || `local-${index}`,
        }))
      },
    },
  },
  created() {
    this.loadPermissions()
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    statusLabel(statusId) {
      if (!statusId) return 'N/A'
      const status = this.statusOptions.find((opt) => opt.id === statusId)
      return status ? status.status : 'N/A'
    },
    statusClass(statusId) {
      if (statusId === 1) return 'status-pill--danger'
      if (statusId === 2) return 'status-pill--warn'
      if (statusId === 3) return 'status-pill--ok'
      return ''
    },
    normalizeDatetime(value) {
      if (!value) return ''
      return value.slice(0, 16)
    },
    normalizeOrderDetails(order) {
      const normalized = { ...order }
      normalized.cause = order?.cause || ''
      normalized.scheduled_for = this.normalizeDatetime(order.scheduled_for)
      normalized.reception_time = this.normalizeDatetime(order.reception_time)
      normalized.start_time = this.normalizeDatetime(order.start_time)
      normalized.estimated_end_time = this.normalizeDatetime(order.estimated_end_time)
      normalized.end_time = this.normalizeDatetime(order.end_time)
      return normalized
    },
    showForm(formName) {
      this.currentForm = formName
    },
    backMainPanel() {
      this.$router.push('/main-panel')
    },
    backMaintenance() {
      this.$router.push('/modulo-mantenimiento')
    },
    formatDatetime(value) {
      if (!value) return ''
      return value.slice(0, 16)
    },
    isCostProvided(value) {
      return value !== null && value !== '' && !Number.isNaN(Number(value))
    },
    async fetchEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/approvers-for-forms`)
        this.employees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching approvers:', error)
      }
    },
    async fetchOperatorEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/operators-for-forms`)
        this.operatorEmployees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching operator employees:', error)
      }
    },
    async fetchMechanicEmployees() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/mechanics-for-forms`)
        this.mechanicEmployees = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching mechanic employees:', error)
      }
    },
    async fetchUnits() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/maintenance/units-for-forms`)
        this.units = response.data.results || []
      } catch (error) {
        console.error('There was an error fetching units:', error)
      }
    },
    formatMoney(value) {
      const num = Number(value)
      if (Number.isNaN(num)) return '0.00'
      return num.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatVoucherDate(value) {
      if (!value) return 'N/A'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return 'N/A'
      return date.toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' })
    },
    requisitionStatusClass(status) {
      if (status === 'fulfilled') return 'status-pill--ok'
      if (status === 'partial') return 'status-pill--warn'
      return 'status-pill--danger'
    },
    supplyClass(item) {
      if (item.is_fulfilled) return 'req-check--done'
      if (Number(item.delivered_quantity) > 0) return 'req-check--partial'
      return ''
    },
    supplyLabel(item) {
      if (item.is_fulfilled) return 'Surtida'
      if (Number(item.delivered_quantity) > 0) return 'Parcial'
      return 'Pendiente'
    },
    emptyRequisitionItem() {
      return {
        part: '',
        query: '',
        quantity: null,
        suggestions: [],
        showSuggestions: false,
        highlight: 0,
      }
    },
    toggleRequisitionForm() {
      this.showRequisitionForm = !this.showRequisitionForm
    },
    addRequisitionItem() {
      this.requisitionItems.push(this.emptyRequisitionItem())
    },
    onPartQuery(item) {
      const normalized = normalizeScannedCode(item.query)
      if (normalized !== item.query) item.query = normalized
      item.part = ''
      item.highlight = 0
      clearTimeout(item.searchTimer)
      const query = (item.query || '').trim()
      if (query.length < 1) {
        item.suggestions = []
        item.showSuggestions = false
        return
      }
      item.searchTimer = setTimeout(() => {
        this.fetchPartSuggestions(item, query)
      }, 180)
    },
    onPartFocus(item) {
      this.requisitionItems.forEach((row) => {
        if (row !== item) row.showSuggestions = false
      })
      if (item.part) return
      const query = (item.query || '').trim()
      if (query.length >= 1) this.fetchPartSuggestions(item, query)
    },
    async fetchPartSuggestions(item, query) {
      const token = (item.searchToken || 0) + 1
      item.searchToken = token
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const response = await axios.get(`${apiDirectory}/warehouse/parts-for-forms`, {
          params: { search: query, limit: 8 },
        })
        if (item.searchToken !== token || (item.query || '').trim() !== query) return
        item.suggestions = response.data.results || []
        item.showSuggestions = item.suggestions.length > 0
        item.highlight = 0
      } catch (error) {
        if (item.searchToken !== token) return
        console.error('Failed to fetch parts for requisition:', error)
        item.suggestions = []
        item.showSuggestions = false
      }
    },
    movePartSuggestion(item, step) {
      if (!item.suggestions.length) return
      const next = item.highlight + step
      const last = item.suggestions.length - 1
      item.highlight = next < 0 ? last : next > last ? 0 : next
      item.showSuggestions = true
    },
    confirmPartSuggestion(item) {
      const part = item.suggestions[item.highlight]
      if (part) this.selectPart(item, part)
    },
    selectPart(item, part) {
      item.part = part.id
      item.query = `${part.barcode} — ${part.name}`
      item.suggestions = []
      item.showSuggestions = false
    },
    hidePartSuggestions(item) {
      setTimeout(() => {
        item.showSuggestions = false
      }, 120)
    },
    async fetchOrderRequisitions() {
      const apiDirectory = process.env.API_DIRECTORY
      const orderId = this.localOrderDetails.id || this.orderId
      if (!orderId) return
      try {
        const response = await axios.post(`${apiDirectory}/warehouse/get-order-requisitions`, {
          maintenance_order: orderId,
        }, { headers: { 'Content-Type': 'application/json' } })
        this.orderRequisitions = response.data || []
      } catch (error) {
        console.error('Failed to fetch order requisitions:', error)
      }
    },
    printOrderRequisition(requisition) {
      printRequisition(requisition)
    },
    printOrderRequisitionTicket(requisition) {
      printRequisitionTicket(requisition)
    },
    async saveRequisition() {
      if (!this.canCreateRequisition) {
        Swal.fire('Sin acceso', 'No tienes permisos para crear requisiciones.', 'warning')
        return
      }
      const orderId = this.localOrderDetails.id || this.orderId
      if (!orderId) {
        Swal.fire('Error', 'No se encontró el ID de la orden de mantenimiento.', 'error')
        return
      }
      const unfinished = this.requisitionItems.some((item) => (item.query || '').trim() && !item.part)
      if (unfinished) {
        Swal.fire('Falta información', 'Elige la pieza desde las sugerencias.', 'warning')
        return
      }
      const items = this.requisitionItems.filter((item) => item.part && Number(item.quantity) > 0)
      if (items.length === 0) {
        Swal.fire('Falta información', 'Agrega al menos una pieza con cantidad mayor a cero.', 'warning')
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      this.savingRequisition = true
      try {
        const response = await axios.post(`${apiDirectory}/warehouse/create-requisition`, {
          maintenance_order: orderId,
          comments: this.requisitionComments || null,
          items: items.map((item) => ({ part: item.part, quantity: item.quantity })),
        }, { headers: { 'Content-Type': 'application/json' } })
        this.requisitionComments = ''
        this.requisitionItems = [this.emptyRequisitionItem()]
        this.showRequisitionForm = false
        await this.fetchOrderRequisitions()
        await Swal.fire({
          title: 'Requisición creada',
          text: `Folio ${response.data.requisition_number}. ¿Deseas imprimirla?`,
          icon: 'success',
          showCancelButton: true,
          showDenyButton: true,
          confirmButtonText: 'Imprimir',
          denyButtonText: 'Imprimir ticket',
          cancelButtonText: 'Después',
        }).then((result) => {
          if (result.isConfirmed) printRequisition(response.data)
          if (result.isDenied) printRequisitionTicket(response.data)
        })
      } catch (error) {
        console.error('Failed to create requisition:', error)
        const message = error.response?.data?.error || 'No se pudo crear la requisición.'
        Swal.fire('Error', message, 'error')
      } finally {
        this.savingRequisition = false
      }
    },
    async fetchLinkedVouchers() {
      const apiDirectory = process.env.API_DIRECTORY
      const orderId = this.localOrderDetails.id || this.orderId
      if (!orderId) return
      try {
        const response = await axios.post(`${apiDirectory}/warehouse/get-order-exit-vouchers`, {
          maintenance_order: orderId,
        }, { headers: { 'Content-Type': 'application/json' } })
        this.linkedVouchers = response.data || []
        this.localOrderDetails.parts_cost = this.vouchersTotal
      } catch (error) {
        console.error('Failed to fetch linked vouchers:', error)
      }
    },
    addAssignation() {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la orden.', 'warning')
        return
      }
      this.localAssignations.push({
        id: null,
        maintenance_order: this.localOrderDetails.id,
        workshop: '',
        mechanic: null,
        start_time: '',
        type_of_maintenance: '',
        comments: '',
        end_time: '',
        status: '',
        localKey: `local-${Date.now()}`,
      })
    },
    async saveAssignation(assignation) {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        if (!this.localOrderDetails.id) {
          await Swal.fire('Error', 'No se encontró el ID de la orden de mantenimiento.', 'error')
          return
        }
        if (!assignation.mechanic) {
          await Swal.fire('Falta el mecánico', 'Selecciona un mecánico antes de guardar.', 'warning')
          return
        }
        if (assignation.end_time && !assignation.start_time) {
          await Swal.fire('Falta inicio', 'No se puede guardar un término sin inicio.', 'warning')
          return
        }
        if (assignation.start_time && !this.localOrderDetails.start_time) {
          const result = await Swal.fire({
            title: 'Actualizar inicio de orden',
            text: '¿Deseas usar este inicio para la orden de mantenimiento?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
          })
          if (result.isConfirmed) {
            this.localOrderDetails.start_time = assignation.start_time
          }
        }
        const payload = {
          maintenance_order: this.localOrderDetails.id,
          workshop: assignation.workshop || null,
          mechanic: assignation.mechanic ? Number(assignation.mechanic) : null,
          start_time: assignation.start_time || null,
          type_of_maintenance: assignation.type_of_maintenance || null,
          comments: assignation.comments || null,
          end_time: assignation.end_time || null,
          status: assignation.status || null,
        }
        if (assignation.id) {
          payload.id = assignation.id
        }
        await axios.post(`${apiDirectory}/set-maintenance-assignations`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        this.$emit('refresh-order')
      } catch (error) {
        console.error('Failed to save assignation:', error)
        Swal.fire('Error', 'No se pudo guardar la asignación.', 'error')
      }
    },
    async saveAllAssignations() {
      const apiDirectory = process.env.API_DIRECTORY
      if (!this.localOrderDetails.id) {
        await Swal.fire('Error', 'No se encontró el ID de la orden de mantenimiento.', 'error')
        return
      }
      const payload = this.localAssignations.map((assignation) => {
        const entry = {
          maintenance_order: this.localOrderDetails.id,
          workshop: assignation.workshop || null,
          mechanic: assignation.mechanic ? Number(assignation.mechanic) : null,
          start_time: assignation.start_time || null,
          type_of_maintenance: assignation.type_of_maintenance || null,
          comments: assignation.comments || null,
          end_time: assignation.end_time || null,
          status: assignation.status || null,
        }
        if (assignation.id) entry.id = assignation.id
        return entry
      })
      await axios.post(`${apiDirectory}/set-maintenance-assignations`, payload, {
        headers: { 'Content-Type': 'application/json' },
      })
    },
    async removeAssignation(assignation, index) {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la orden.', 'warning')
        return
      }
      if (!assignation.id) {
        this.localAssignations.splice(index, 1)
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      try {
        await axios.post(`${apiDirectory}/delete-maintenance-assignations`, { id: assignation.id })
        this.$emit('refresh-order')
      } catch (error) {
        console.error('Failed to delete assignation:', error)
        Swal.fire('Error', 'No se pudo eliminar la asignación.', 'error')
      }
    },
    async saveOrder() {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la orden.', 'warning')
        return
      }
      const apiDirectory = process.env.API_DIRECTORY
      try {
        this.savingOrder = true
        const payload = {
          ...this.localOrderDetails,
          scheduled_for: this.localOrderDetails.scheduled_for || null,
          reception_time: this.localOrderDetails.reception_time || null,
          start_time: this.localOrderDetails.start_time || null,
          estimated_end_time: this.localOrderDetails.estimated_end_time || null,
          end_time: this.localOrderDetails.end_time || null,
          parts_cost: this.localOrderDetails.parts_cost ?? null,
          labor_cost: this.localOrderDetails.labor_cost ?? null,
          total_cost: this.total_cost,
        }
        await axios.put(`${apiDirectory}/maintenance-orders/${this.localOrderDetails.id}/`, payload, {
          headers: { 'Content-Type': 'application/json' },
        })
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          background: '#d4edda',
          title: '¡Guardado!',
          text: 'Los datos del formulario se han guardado con éxito.',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        })
        this.$emit('refresh-order')
      } catch (error) {
        console.error('Failed to update maintenance order:', error)
        Swal.fire('Error', 'Hubo un problema al actualizar la orden.', 'error')
      } finally {
        this.savingOrder = false
      }
    },
    async saveAll() {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la orden.', 'warning')
        return
      }
      try {
        this.savingOrder = true
        await this.saveOrder()
        await this.saveAllAssignations()
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          background: '#d4edda',
          title: '¡Guardado!',
          text: 'Se guardaron la orden y las asignaciones.',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        })
        this.$emit('refresh-order')
      } catch (error) {
        console.error('Failed to save all', error)
        Swal.fire('Error', 'No se pudieron guardar los cambios.', 'error')
      } finally {
        this.savingOrder = false
      }
    },
    async completeOrder() {
      if (!this.canUpdate) {
        Swal.fire('Sin acceso', 'No tienes permisos para modificar la orden.', 'warning')
        return
      }
      try {
        this.savingOrder = true
        this.localOrderDetails.status = 4
        await this.saveOrder()
        await Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          background: '#d4edda',
          title: 'Completado',
          text: 'La orden fue marcada como completada.',
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true,
        })
        this.$emit('refresh-order')
      } catch (error) {
        console.error('Failed to complete order', error)
        Swal.fire('Error', 'No se pudo completar la orden.', 'error')
      } finally {
        this.savingOrder = false
      }
    },
  },
}
</script>

<style scoped>
.logo-button {
  height: 40px;
}

.nav-bar-operations {
  height: 50px;
}

.note-container {
  padding: 0 15px;
  overflow-x: auto;
}

.create-order {
  display: flex;
  padding: 5px 0;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.create-order h3 {
  font-size: 18px;
  font-weight: bold;
  padding-right: 10px;
}

.create-order .left {
  display: flex;
  align-items: center;
  gap: 6px;
}

.create-order .right {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
}

@media (max-width: 1200px) {
  .create-order {
    flex-direction: column;
    align-items: flex-start;
  }
  .create-order .right {
    width: 100%;
  }
}

.create-order button {
  padding: 5px 15px;
  background-color: #d5171d;
  color: white;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: .3s all;
}

.create-order button.active {
  background-color: #111827;
}

.create-order button:hover {
  background: black;
}

.main-data-container {
  display: grid;
  grid-template-columns: repeat(14, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.container-card {
  border: 1px solid #f3f3f3;
  border-radius: 0px;
  margin-bottom: 0px;
  border-top: none;
}

.container-card-body {
  padding: 5px 8px;
}

.title {
  background: #f2f7fa;
  padding: 5px 15px;
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title h4 {
  font-size: 16px;
  text-align: left;
  line-height: 20px;
  margin-bottom: 0;
  font-weight: 700;
}

.maintenance-title-row {
  justify-content: space-between;
}

.folio-badge {
  font-size: 12px;
  color: #6b6b6b;
  font-weight: 600;
}

.maintenance-general {
  grid-column: span 10;
}

.maintenance-side {
  grid-column: span 4;
  display: grid;
  gap: 12px;
}

.maintenance-general-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 16px;
}

.maintenance-column {
  display: grid;
  gap: 8px;
}

.form-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-input-group label {
  min-width: 110px;
  margin: 0;
}

.form-input-group.full-width {
  margin-top: 8px;
}

input[type=text],
input[type=number],
input[type=datetime-local],
select,
textarea {
  padding: 1.5px 8px;
  width: 100%;
  font-size: 11px;
  border: 1px solid #ececec;
  border-radius: 5px;
  font-weight: 500;
  outline: none;
  margin-bottom: 0;
}

input[type=text]:focus,
input[type=number]:focus,
input[type=datetime-local]:focus,
select:focus,
textarea:focus {
  border: 1px solid #ffc736;
}

.form-input-group input,
.form-input-group select,
.form-input-group textarea {
  flex: 1;
}

label {
  display: block;
  font-size: 11px;
  margin-bottom: 0;
  font-weight: 600;
  color: #929292;
}

.form-input-group label {
  margin-top: 2px;
}

textarea {
  min-height: 64px;
  resize: vertical;
}

.invalid {
  border-color: #d9534f !important;
  background: #fff3f3;
}

.radio-group {
  display: flex;
  gap: 12px;
  font-size: 11px;
  color: #6b6b6b;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 12px 0 16px;
}

.btn-submit-save {
  background-color: #2ada85;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
}

.btn-submit-cancel {
  background-color: #d5171d;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

.btn-submit-complete {
  background-color: #0f7a3b;
  color: #fff;
  border: none;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
}

.time-disclaimer {
  font-size: 11px;
  color: #9d1a1a;
  background: #fdecec;
  border: 1px solid #f5b5b5;
  padding: 6px 8px;
  border-radius: 6px;
  margin-bottom: 6px;
}

.save-disclaimer {
  font-size: 12px;
  color: #8a6100;
  background: #fff6e5;
  border: 1px solid #f2dfb2;
  padding: 8px 10px;
  border-radius: 6px;
  margin: 4px 0 12px;
}

.assignations-actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}

.assignations-extra-fields {
  display: grid;
  gap: 10px;
}

.grupo-block {
  border: 1px solid #f0f0f0;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
}

.assignation-row {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 140px;
}

.assignation-row label {
  min-width: 110px;
  margin: 0;
}

.assignation-row input,
.assignation-row select {
  width: 160px;
}

.assignation-row--comments {
  display: flex;
  align-items: flex-start;
  flex: 1 1 100%;
  min-width: 280px;
}

.assignation-comments {
  width: 100%;
  min-height: 72px;
  resize: vertical;
}

.status-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 11px;
  background: #eef2f7;
  color: #334155;
  border: 1px solid #e2e8f0;
}

.status-pill--danger {
  background: #fdecec;
  color: #9d1a1a;
  border-color: #f5b5b5;
}

.status-pill--warn {
  background: #fff6e5;
  color: #8a6100;
  border-color: #f2dfb2;
}

.status-pill--ok {
  background: #e8f7ef;
  color: #0f7a3b;
  border-color: #bde6cd;
}

.assignation-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-delete-icon {
  background-color: #d5171d;
  color: #fff;
  border: none;
  border-radius: 6px;
  width: 24px;
  height: 24px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  font-weight: 700;
}

.placeholder-text {
  font-size: 12px;
  color: #9aa0a6;
}

.piezas-title {
  justify-content: space-between;
}

.piezas-link-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.piezas-link-controls input {
  width: 220px;
  padding: 3px 8px;
  font-size: 11px;
  border: 1px solid #ececec;
  border-radius: 5px;
  outline: none;
}

.piezas-link-controls input:focus {
  border-color: #ffc736;
}

.voucher-block {
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 10px;
}

.voucher-header {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 11px;
  color: #6b6b6b;
  margin-bottom: 6px;
}

.voucher-folio {
  background: #eef2f7;
  border: 1px solid #e2e8f0;
  padding: 2px 9px;
  border-radius: 999px;
  font-weight: 700;
  color: #334155;
}

.voucher-header .btn-delete-icon {
  margin-left: auto;
}

.piezas-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

.piezas-table th {
  background: #f2f7fa;
  padding: 4px 8px;
  text-align: left;
  font-weight: 700;
}

.piezas-table td {
  padding: 4px 8px;
  border-bottom: 1px solid #f7f7f7;
}

.voucher-subtotal {
  text-align: right;
  font-size: 11px;
  font-weight: 700;
  margin-top: 4px;
}

.piezas-total {
  text-align: right;
  font-size: 13px;
  font-weight: 700;
  color: #0f7a3b;
  margin-top: 6px;
}

.requisition-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.requisition-add-row {
  display: flex;
}

.requisition-save {
  align-self: flex-start;
  margin-top: 4px;
}

.requisition-item-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.part-suggest {
  position: relative;
  flex: 1;
  min-width: 0;
}

.part-suggest input,
.requisition-item-row .requisition-qty {
  padding: 6px 8px;
  font-size: 12px;
  border: 1px solid #ececec;
  border-radius: 5px;
  outline: none;
}

.part-suggest input {
  width: 100%;
  box-sizing: border-box;
}

.part-suggest input:focus,
.requisition-item-row .requisition-qty:focus {
  border-color: #ffc736;
}

.requisition-item-row .requisition-qty {
  width: 110px;
  flex: none;
}

.part-suggestions {
  position: absolute;
  z-index: 30;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border: 1px solid #e4e8ef;
  border-radius: 6px;
  max-height: 220px;
  overflow: auto;
  box-shadow: 0 8px 20px rgba(16, 24, 40, 0.12);
}

.part-suggestions li {
  padding: 8px 10px;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.35;
}

.part-suggestions li.hovered,
.part-suggestions li:hover {
  background: #f4f7ff;
}

.part-suggest-stock {
  display: block;
  color: #667085;
  font-size: 11px;
}

.req-check {
  width: 16px;
  height: 16px;
  border: 2px solid #94a3b8;
  border-radius: 3px;
  display: inline-grid;
  place-items: center;
  background: #fff;
}

.req-check--done {
  background: #0f7a3b;
  border-color: #0f7a3b;
}

.req-check--done::after {
  content: '';
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) translate(-1px, -1px);
}

.req-check--partial {
  background: #ffc434;
  border-color: #d9a000;
}

.req-check--partial::after {
  content: '';
  width: 8px;
  height: 2px;
  background: #3a2a00;
}

.note-container {
  padding-top: 50px;
}
.nav-bar-operations {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>
